import {CanvasProducts} from "../canvas/canvas.component";
import {RoomConfigurationInterface} from "../services/configuration.loader";
import {ProductGroup} from "../model/product.group";
import {Base64} from "./base64";
import {Logger} from "../utils/logger";


interface StateParams {
    productGroups: Array<{
        name: string,
        productArticle: string,
        alternativeNumber: number
    }>

    subProductGroups: Array<{
        name: string,
        productArticle: string,
        alternativeNumber: number
    }>
}

export class PageState {

    public corrupted: boolean = false;


    constructor(private params?: StateParams) {

    }

    static fromString(str: string) {
        let res: StateParams = null;
        let isCorrupted = false;
        let parse = (str): StateParams => {
            if (str.length > 0) {
                let tmp = Base64.decode(str);
                if (tmp) {
                    try {
                        res = JSON.parse(tmp) as StateParams;
                    } catch (e) {
                        res = null;
                        isCorrupted = true;
                    }
                }
            }
            return res;
        };
        let params = parse(str);
        let state = null;
        if (params) {
            state = new PageState(params);
        } else {
            state = new PageState();
        }
        if (isCorrupted) {
            state.corrupted = isCorrupted;
        }
        return state;
    }

    setSelectedProducts(products: Array<ProductGroup>, subProducts: Array<ProductGroup>) {
        let _state = {
            productGroups: [],
            subProductGroups: []
        };

        products.forEach((group: ProductGroup) => {
            // this.logger.debug("persist state group ", group);

            _state.productGroups.push({
                name: group.getName(),
                productArticle: group.getProducts()[0].articleNumber.getValue(),
                alternativeNumber: group.getAltNumber()
            });
        });

        subProducts.forEach((group: ProductGroup) => {
            if (group.getSubProducts() != null) {
                _state.subProductGroups.push({
                    name: group.getName(),
                    productArticle: group.getSubProducts()[0].articleNumber.getValue(),
                    alternativeNumber: group.getAltNumber()
                });
            }
        });

        this.params = _state;
    }

    toString() {
        let tmp = JSON.stringify(this.params);
        return encodeURIComponent(Base64.encode(tmp));
    }

    isProductsEmpty() {
        return !this.params || this.params.productGroups.length == 0;
    }

    isSubProductsEmpty() {
        return !this.params || this.params.subProductGroups.length == 0;
    }

    isCorrupted() {
        return this.corrupted;
    }

    getProductsParams(): Array<{
        name: string,
        productArticle: string,
        alternativeNumber: number
    }> {
        return this.params.productGroups;
    }

    getSubProductsParams(): Array<{
        name: string,
        productArticle: string
    }> {
        return this.params.subProductGroups;
    }

}

export class PageStatePersister {

    private state: PageState = null;
    private selectedProducts: Array<ProductGroup> = [];
    private selectedSubProducts: Array<ProductGroup> = [];

    constructor(private stateStr?: string, private groups?: Array<ProductGroup>) {
        let tmp = this.stateStr ? decodeURIComponent(this.stateStr) : "";
        this.state = PageState.fromString(tmp);
    }

    persistState(selectedProducts: Array<ProductGroup>, selectedSubProducts: Array<ProductGroup>): string {
        this.selectedProducts = selectedProducts;
        this.selectedSubProducts = selectedSubProducts;

        this.state.setSelectedProducts(selectedProducts, selectedSubProducts);

        return this.state.toString();
    }

    retrieveState(): Array<ProductGroup> {
        let productsRes = [];
        let subProductsRes = [];
        let res = null;

        if (!this.state.isProductsEmpty()) {
            res = [];
            this.state.getProductsParams().forEach((item) => {
                this.groups.forEach((group: ProductGroup) => {
                    if (group.getName() == item.name) {
                        let product = group.getProductByArticleNumber(item.productArticle);
                        let currentProductData = {};

                        group.setAltNumber(item.alternativeNumber);

                        if (product) {
                            currentProductData['group'] = group;
                            currentProductData['product'] = product;

                            productsRes.push(currentProductData);

                            return false;
                        }
                    }
                });
            });
        }

        if (!this.state.isSubProductsEmpty()) {
            this.state.getSubProductsParams().forEach((item) => {
                this.groups.forEach((group: ProductGroup) => {
                    if (group.getName() == item.name) {
                        let subProduct = group.getSubProductByArticleNumber(item.productArticle);
                        let currentSubProductData = {};

                        if (subProduct) {
                            currentSubProductData['group'] = group;
                            currentSubProductData['subProduct'] = subProduct;

                            subProductsRes.push(currentSubProductData);

                            return false;
                        }
                    }
                });
            });
        }

        let productCount = 0;
        productsRes.forEach((product) => {
            if (subProductsRes[productCount] != undefined) {
                res.push(ProductGroup.clone(product['group'], [product['product']], [subProductsRes[productCount]['subProduct']]));
            } else {
                res.push(ProductGroup.clone(product['group'], [product['product']], null));
            }
            productCount++;
        });

        if (this.state.isCorrupted()) {
            res = false;
        }

        // console.log(res);
        return res;
    }

}


// WEBPACK FOOTER //
// ./src/app/utils/page_state.ts